import { grey300, grey500, grey800, grey600, grey700 } from "material-ui/styles/colors"
import { ISchedulePatternTemplate, ITimecardPriorPeriodData, } from "../models"
import { IScheduleBudgetDay } from "../models/data/scheduling/ScheduleBudgetDay"
import { IScheduleBudgetDayPosition } from "../models/data/scheduling/ScheduleBudgetDayPosition"
import * as positionHelper from "../helpers/positionHelper"

const diffBlue = "#0075FB"
const diffBlueText = "#7DB7F9"
const diffBlueButtonHover = "#3B93F9"
const diffBlueTextLight = "#80BAFD"

const darkGreyColor = grey700
const reExportHoverColor = "#cccccc"

export function getTimecardPrimaryColor(timecardPriorPeriodData: ITimecardPriorPeriodData) {
	if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceExported) {
		return grey500
	} else if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceTimecard) {
		return diffBlue
	} else {
		return darkGreyColor
	}
}


export function getTimecardPrimaryColorHover(timecardPriorPeriodData: ITimecardPriorPeriodData) {
	if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceExported) {
		return reExportHoverColor
	} else if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceTimecard) {
		return diffBlueButtonHover
	} else {
		return darkGreyColor
	}
}

export function getTimecardPrimaryTextColor(timecardPriorPeriodData: ITimecardPriorPeriodData) {
	if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceExported) {
		return grey300
	} else if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceTimecard) {
		return diffBlueText
	} else {
		return grey500
	}
}

export function getTableRowColumnColor(timecardPriorPeriodData: ITimecardPriorPeriodData) {
	if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceExported) {
		return grey500
	} else if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceTimecard) {
		return diffBlue
	} else {
		return grey800
	}
}

export function getTotalsRowTextColor(timecardPriorPeriodData: ITimecardPriorPeriodData) {
	if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceExported) {
		return darkGreyColor
	} else if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceTimecard) {
		return diffBlue
	} else {
		return darkGreyColor
	}
}

export function getExpenseTextLightColor(timecardPriorPeriodData: ITimecardPriorPeriodData) {
	if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceExported) {
		return grey600
	} else if (timecardPriorPeriodData && timecardPriorPeriodData.DifferenceTimecard) {
		return diffBlueTextLight
	} else {
		return grey500
	}
}


export function getUserTypeColorCode(float, perDiem, agency) {
	if (!float && !perDiem && !agency) return null

	if (float) return "blue"
	if (perDiem) return "red"
	if (agency) return "green"
}

export function getBudgetPositionColor(pt: ISchedulePatternTemplate, budgetDay: IScheduleBudgetDay): string {
	const shiftPositionColor = pt.ShiftTemplates[0].Position ? pt.ShiftTemplates[0].Position.Color : ""
	if (!budgetDay || !budgetDay.BudgetPositions) {
		return shiftPositionColor
	}

	let positionDay = budgetDay.BudgetPositions.find((item) => {
		if (!item.Unit || !pt.ShiftTemplates[0].Position) return false
		return item.Unit.PositionBaseId === pt.ShiftTemplates[0].Position.BasePositionId
	})

	if (!positionDay) {
		return shiftPositionColor
	}

	const position = positionDay.Unit.PositionBaseId
	if (!position) {
		return shiftPositionColor
	}

	//	const returnColor = positionHelper.getPositionColorFromBasePositionId(budgetDay..Unit.PositionBaseId)

	return "" //position.Color
}

export function getBudgetUnitColor(row: IScheduleBudgetDayPosition) {
	if (row && row.Unit) {
		const returnColor = positionHelper.getPositionColorFromBasePositionId(row.Unit.PositionBaseId)
		return returnColor
	} else {
		return null
	}
}

export function getEmployeeTypeStyleData(float, perDiem, agency) {
	if (!float && !perDiem && !agency) return { className: "fa-duotone fa-circle-c", color: undefined }
	if (float) return { className: "fa-duotone fa-circle-f", color: "#0075FB" }
	if (perDiem) return { className: "fa-duotone fa-circle-p", color: "#38006b" }
	if (agency) return { className: "fa-duotone fa-circle-a", color: "#c43e00" }
}
